// extracted by mini-css-extract-plugin
module.exports = {"category":"J_1Td","skeleton":"_3efOx","loading":"_1OL0J","loadingDesktop":"_1ySeI"};